import React from "react"

// `caption` replaces the line under the heading, so a host page can say what
// the code is for in its own words (#340). Unset, the generic line shows.
export default function BuilderHero({ compact = false, align = "center", caption }) {
  const left = align === "left"
  return (
    <header className={(compact ? "mb-6 " : "mb-8 ") + (left ? "text-left" : "text-center")}>
      {/* 32px / 1.02 / -0.03em on a phone, per the mobile design handoff — the
          hero copy beside the builder is off screen there, so this headline is
          doing the whole job of saying what the page is. */}
      <h2
        className={
          "font-display font-extrabold leading-[1.02] tracking-[-0.03em] " +
          (compact ? "text-2xl" : "text-[32px] sm:text-3xl")
        }
      >
        <span className="text-voltage">Make</span>
        <span className="text-ink dark:text-cloud"> a QR code.</span>
      </h2>
      {!compact && (
        <p className={"mt-3 text-base leading-relaxed text-[color:var(--color-muted)] dark:text-muted-light max-w-md " + (left ? "" : "mx-auto")}>
          {caption || "Paste a link. We'll give you a QR you can change later — for free."}
        </p>
      )}
    </header>
  )
}
